module.exports = __webpack_public_path__ + "img/daishouhuo.2eeba4a5.png";